// src/components/LoginPage.js
import React, { useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { Link } from 'react-router-dom';
import AuroraBackground from './AuroraBackground';
import logo from '../img/tubetactix-logo.svg';

const LoginPage = ({ handleLogin, loginError }) => {
  // Local state for errors that happen before our backend is even called.
  const [clientError, setClientError] = useState('');

  return (
    <>
      <AuroraBackground />
      <div className="login-page-container">
        <div className="login-box">
          <div className="flex items-center justify-center gap-3 mb-5">
            <img src={logo} alt="TubeTactix Logo" className="h-8 w-8" />
            <h2 className="main-logo text-white text-2xl font-bold">TubeTactix</h2>
          </div>
          <h1 class="mt-5">The Smarter Way to Grow on YouTube</h1>
          <p>Your AI-powered YouTube Strategy Assistant</p>

          <ul className="login-features">
            <li>✓ Discover high-impact keywords instantly.</li>
            <li>✓ Uncover any competitor's winning strategy.</li>
            <li>✓ Craft viral-ready scripts with AI intelligence.</li>
          </ul>

          {/* Display either the backend error or the client-side error */}
          {(loginError || clientError) && (
            <p className="error-message login-error">{loginError || clientError}</p>
          )}

          <div className="google-login-button-container">
            <GoogleLogin
              onSuccess={handleLogin}
              onError={() => {
                console.error('Google Login Failed');
                setClientError(
                  'Google sign-in failed. Please check your connection and allow popups, then try again.'
                );
              }}
              theme="filled_black"
              size="large"
              shape="pill"
            />
          </div>
          <p className="login-terms">
            By signing in, you agree to our{' '}
            <Link to="/terms" className="text-gray-400 hover:underline hover:text-blue-400 transition-colors">
              Terms of Service
            </Link> and{' '}
            <Link to="/privacy" className="text-gray-400 hover:underline hover:text-blue-400 transition-colors">
              Privacy Policy
            </Link>.
          </p>
        </div>
      </div>
    </>
  );
};

export default LoginPage;